/**
 * @generated SignedSource<<87e38f2456de49f5f457aa6a152b7860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectSubmissionStatusEnum = "private" | "public";
export type UpdateProjectSubmissionInput = {
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  projectSubmissionId?: string | null | undefined;
  projectSubmissionRawId?: number | null | undefined;
  screenshotUrl?: string | null | undefined;
  status?: ProjectSubmissionStatusEnum | null | undefined;
  url?: string | null | undefined;
};
export type ProjectSubmissionsField_UpdateProjectSubmissionMutation$variables = {
  input: UpdateProjectSubmissionInput;
};
export type ProjectSubmissionsField_UpdateProjectSubmissionMutation$data = {
  readonly updateProjectSubmission: {
    readonly projectSubmission: {
      readonly status: ProjectSubmissionStatusEnum | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectSubmissionsField_UpdateProjectSubmissionMutation = {
  response: ProjectSubmissionsField_UpdateProjectSubmissionMutation$data;
  variables: ProjectSubmissionsField_UpdateProjectSubmissionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectSubmissionsField_UpdateProjectSubmissionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectSubmissionPayload",
        "kind": "LinkedField",
        "name": "updateProjectSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSubmission",
            "kind": "LinkedField",
            "name": "projectSubmission",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectSubmissionsField_UpdateProjectSubmissionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectSubmissionPayload",
        "kind": "LinkedField",
        "name": "updateProjectSubmission",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectSubmission",
            "kind": "LinkedField",
            "name": "projectSubmission",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f376162f5486c51938c69d3ebd29ca2e",
    "id": null,
    "metadata": {},
    "name": "ProjectSubmissionsField_UpdateProjectSubmissionMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectSubmissionsField_UpdateProjectSubmissionMutation(\n  $input: UpdateProjectSubmissionInput!\n) {\n  updateProjectSubmission(input: $input) {\n    projectSubmission {\n      status\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "558b49b9fe10dc992e860295029f2ea0";

export default node;
